import React from 'react'

export const Footer = () => {
    var style = {
        backgroundColor: "#454545",
        borderTop: "1px solid #E7E7E7",
        color: 'white',
        fontSize: 'small',
        fontFamily: 'Rubik',
        textAlign: "center",
        padding: "20px",
        position: "relative",
        margin: "0",
        left: "0",
        bottom: "0",
        height: "60px",
        width: "100%",
    }

    var phantom = {
        display: 'block',
        padding: '20px',
        height: '60px',
        width: '100%',
    }
    return (
        <div className="FooterContainer">
        <div style={phantom}/>
        <div style={style}>
         © <span style={{fontWeight: 800}}>Sivakasi Nadars</span>. All Rights Reserved.
        </div>
        </div>
    )
}